import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {RoomPartyOption} from '../../../graphql/groups.datatypes';

export interface DeleteRoomPartyOptionInput {
    id: number
}

interface DeleteRoomPartyOptionData {
    deleteRoomPartyOption: RoomPartyOption,
}

export const DELETE_ROOM_PARTY_MEMBER_OPTION_MUTATION = gql`
  mutation deleteRoomPartyOption($id: Int!){
    deleteRoomPartyOption(id: $id) {
      id
      room_party_id
      group_resource_option_id
      unit_count
      unit_cost
    }
  }
`;

export const deleteRoomPartyOption = () => {
    return useMutation<DeleteRoomPartyOptionData, DeleteRoomPartyOptionInput>(
        DELETE_ROOM_PARTY_MEMBER_OPTION_MUTATION,
        {
            update: updateCacheByType('RoomPartyOption'),
        }
    );
};

export default deleteRoomPartyOption;